import { gql } from '@apollo/client';

export const GET_COURSE_REVIEWS = gql`
  query GetCourseReviews($contentId: Uuid!) {
    ratingReview(
      where: {
        contentId: { _eq: $contentId }
        flagged: { _eq: false }
      }
      order_by: { createdAt: Desc }
    ) {
      id
      rating
      reviewTitle
      reviewDescription
      createdAt
      reviewerId
      user {
      id
        _AuthUser {
          username
        }
      }
    }
  }
`;
